export default __webpack_public_path__ + "static/media/WF4.860ac2d2.png";